import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { StatsCards } from "@root/components/pledge-dashboard/stats-cards";
import { RecentActivities } from "./recent-activities";
import { TopCourses } from "./top-courses";
import JournalistRequests from "./journalist-approval-requests";
import { DashboardHeader } from "@root/components/UnauthenticatedDashboard/DashboardHeader";

export const PledgeDashboard = () => {
  return (
    <>
      <Box minH="100vh" overflowY={"auto"} width="100%" padding={"24px 16px"}>
        <Box mb={4}>
          <DashboardHeader />
        </Box>

        {/* Stats Cards */}
        <StatsCards />

        {/* Recent Activates & Top Courses */}
        <Flex
          gap={4}
          mb={6}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          borderRadius={"20px"}
        >
          {/* Recent Activities */}
          <RecentActivities />

          {/* Top Courses */}
          <TopCourses />
        </Flex>

        {/* Journalist Approval Requests */}
        <JournalistRequests />
      </Box>
    </>
  );
};
